module.exports = __webpack_public_path__ + "static/privat24-e27b345aeae512192cb20ca46ac4f65c.webp";